module.exports = __webpack_public_path__ + "img/9788994475226.a0ef3b3d.jpg";